
document.addEventListener("DOMContentLoaded", function() {
  // Gestión de los botones de grupos de filtros
  const groupButtons = document.querySelectorAll(".filter-group-btn");
  
  groupButtons.forEach(button => {
    button.addEventListener("click", function() {
      const groupId = this.getAttribute("data-group");
      const relatedTags = document.getElementById(groupId + "-tags");
      
      // Si este grupo ya está activo, lo ocultamos y quitamos la clase activa
      if (this.classList.contains("active")) {
        this.classList.remove("active");
        if (relatedTags) {
          relatedTags.classList.add("hidden");
        }
      } else {
        // Quitamos la clase activa de todos los botones de grupo
        groupButtons.forEach(btn => btn.classList.remove("active"));
        
        // Ocultamos todos los grupos de etiquetas
        document.querySelectorAll(".filter-tags").forEach(group => group.classList.add("hidden"));
        
        // Activamos este botón y mostramos sus etiquetas
        this.classList.add("active");
        if (relatedTags) {
          relatedTags.classList.remove("hidden");
        }
      }
    });
  });
  
  // Gestión de los botones de filtro (tags)
  const filterButtons = document.querySelectorAll(".filter-btn");
  const products = document.querySelectorAll(".product-item");
  
  // Para depuración - imprime los tags de productos
  console.log("Productos y sus tags:");
  products.forEach(product => {
    console.log(product.getAttribute("data-tags"));
  });

  // Función para actualizar la visualización de productos basada en filtros seleccionados
  function updateProductDisplay() {
    // Recopilamos todos los filtros activos
    const activeFilters = [];
    
    document.querySelectorAll(".filter-btn.active").forEach(button => {
      const filter = button.getAttribute("data-filter");
      if (filter && filter !== "all") {
        activeFilters.push(filter);
      }
    });
    
    console.log("Filtros activos:", activeFilters);
    
    // Si no hay filtros activos, mostramos todos los productos
    if (activeFilters.length === 0) {
      products.forEach(product => {
        product.style.display = "block";
      });
      return;
    }
    
    // Con filtros activos, mostramos sólo los productos que coincidan con TODOS los filtros seleccionados
    products.forEach(product => {
      const productTagsStr = product.getAttribute("data-tags");
      console.log("Product tags string:", productTagsStr);
      
      // Check if ALL active filters are contained within the product tags string
      const matches = activeFilters.every(filter => 
        productTagsStr.includes(filter)
      );
      
      console.log("Product matches ALL filters?", matches);
      product.style.display = matches ? "block" : "none";
    });
  }

  // Añadir evento click a los botones de filtro
  filterButtons.forEach(button => {
    button.addEventListener("click", function() {
      if (this.getAttribute("data-filter") === "all") {
        document.querySelectorAll(".filter-btn").forEach(btn => btn.classList.remove("active"));
      } else {
        this.classList.toggle("active");
      }
      
      console.log("Filtro clickeado:", this.getAttribute("data-filter"));
      console.log("Estado activo:", this.classList.contains("active"));
      
      updateProductDisplay();
    });
  });
});